import { orderDataStatistics } from "@/api/myOrder";

export default {
    namespaced: true,
    state: {
        returnCount: 0, //未完成售后数量（申请中 + 进行中）
    },
    mutations: {
        SET_RETURN_COUNT(state, data) {
            state.returnCount = data
        },
    },
    actions: {
        getReturnCount({ commit }) {
            return orderDataStatistics().then((res) => {
                if (res.data.status == 200) {
                    commit('SET_RETURN_COUNT', Number(res.data.data.returnCount) || 0)
                }
            }).catch(() => {});
        },
    }
}
